import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';

import { CommonDataService } from '../../services/common-data.service';

@Component({
  selector: 'app-glossary-term-usage',
  templateUrl: './glossary-term-usage.component.html'
})
export class GlossaryTermUsageComponent implements OnInit {

  @Output() myEvent = new EventEmitter<string>();
  @Input() GlossaryTermData:any=[];
  termData:any=[];
  termUsageTitle:string="";
  termUsageDef:string="";

  constructor(private commonDataService:CommonDataService, private route:Router) { }

  ngOnInit(): void {
    this.termData = this.GlossaryTermData;
    let globalLabels=this.commonDataService.globalLabels.getValue();
    if(globalLabels!=null){
      this.termUsageTitle = globalLabels?.content?.data?.labels?.find(x => x.key == 'glossary_termUsage')?.value;
      this.termUsageDef = globalLabels?.content?.data?.labels?.find(x => x.key == 'glossarytermUsage_def')?.value;
    }
  }

  navigateToContent(event,termData) {
    event.preventDefault();
    this.commonDataService.parentComponentDetails.next([]);
    this.commonDataService.glossaryTermFromContentPageBackButton.next(this.termData.name);
    let url = termData.publicationId + "/" + termData.topicId + "/" + termData.paragraphId;
    //this.route.navigateByUrl(url);
    window.open(url)
    //this.route.navigateByUrl("/1852827/1830712")
    this.myEvent.emit();
  }

  onRightClick(event, termData){
    let url = termData.publicationId + "/" + termData.topicId + "/" + termData.paragraphId;
    if(event.target.tagName.toLowerCase()!='a' && event.target.parentNode.tagName.toLowerCase()=='a'){
      event.target.parentNode.setAttribute('href',url);
    }
    else if(event.target.tagName.toLowerCase()=='a' && event.target.parentNode.tagName.toLowerCase()!='a'){
      event.target.setAttribute('href',url);
    }
    
  }


  mouseOverFunctions(event, termData){
    // event.srcElement.setAttribute("href", "/" + termData.publicationId + "/" + termData.topicId + "/" + termData.paragraphId);
  }

  ngOnDestroy():void{
    this.commonDataService.glossaryTermData.next([]);
  }

  OpenInlineGlossary(event){
    let id = event.target.id==""?event.target.parentNode.id:event.target.id;
    
    this.commonDataService.rightOverlayOption.next("inline-glossary");
    this.commonDataService.rightPanelWidth.next("rightOverLay_small");
    this.commonDataService.glossaryTermId.next(id);
    this.commonDataService.showRightPanel.next(true);
    let obj=this.commonDataService.parentComponentDetails.getValue();
    obj.push({
      source:"glossary-term-usage",
      data:this.termData,
      panelWidth:"rightOverlay_large"
    })

    this.commonDataService.parentComponentDetails.next(obj);
  }

}
